import React, { createContext, useContext } from 'react';

import { usePlanningByLevel } from './hook/usePlanningByLevel';

const ContextPlanningByLevel = createContext<
	ReturnType<typeof usePlanningByLevel>
>({} as any);

export const ProviderPlanningByLevel: React.FC<{
	children: React.ReactNode;
}> = ({ children }) => {
	const planningByLevel = usePlanningByLevel();

	return (
		<ContextPlanningByLevel.Provider value={planningByLevel}>
			{children}
		</ContextPlanningByLevel.Provider>
	);
};

export const useContextPlanningByLevel = () =>
	useContext(ContextPlanningByLevel);

export default ContextPlanningByLevel;
